/* eslint-disable import/no-anonymous-default-export */
export default {
  userDetails: '/users/me',
  userPreferences: '/users/me/preferences',
  userConsent: '/users/me/consent',
  userLogout: '/users/logout',
  userSignup: '/users/sign-up',
  userDetailsbyId: (id: string) => `/users/${id}`,
  userModulesById: (id: string) => `/visualization/users/${id}/details`,
  userModules: '/visualization/modules',
  userSubmodules: (moduleId: string) => `/visualization/modules/${moduleId}/submodules`,
  userSubmoduleFilters: (submoduleId: string) => `/visualization/submodules/${submoduleId}/filters`,
  userSubmoduleFiltersValues: (submoduleId: string, filterId: string) =>
    `/visualization/submodules/${submoduleId}/filters/${filterId}/values`,
  userGuestToken: (submoduleId: string) => `/visualization/submodules/${submoduleId}/token`,
  userSubmoduleGames: (submoduleId: string, gamesParam: string[]) =>
    `/visualization/submodules/${submoduleId}/games${gamesParam?.length ? `?gameIds=${gamesParam.join(',')}` : ''}`,
  userSubmoduleCompanies: (submoduleId: string) =>
    `/visualization/submodules/${submoduleId}/companies`,
  users: '/users',
  allUsers: '/users/all-users',
  internalAccessTemplateTypes: '/users/internal-users/access-template-types',
  internalAccessTemplateTypesList: '/users/internal-users/access-template-types/list',
  dealSources: '/users/deal-sources',
  onboardingRequest: '/users/onboarding/join-workspace',
  onboardingFeedback: '/users/onboarding/feedback',

  banners: '/v2/banners',

  companies: '/companies',
  companyUsers: (companyId: string) => `/companies/${companyId}/users`,
  fundingCalculator: 'lead-magnet',
  fundingCalculatorDeatils: (id: string) => `/lead-magnet/${id}`,
  charts: (submoduleId: string) => `/visualization/submodules/${submoduleId}/charts`,
  chartById: (submoduleId: string, chartId: string, queryParams?: string) =>
    `/visualization/submodules/${submoduleId}/charts/${chartId}${queryParams || ''}`,
  customDashboardFilters: (submoduleId: string) =>
    `/visualization/submodules/${submoduleId}/filter-values`,
  getChartsSpecificFilterValues: (submoduleId: string, chartId: string) =>
    `/visualization/submodules/${submoduleId}/charts/${chartId}/filter-values`,
  getChartsSpecificFilterValuesByGameId: (submoduleId: string, chartId: string, gameId: string) =>
    `/visualization/submodules/${submoduleId}/charts/${chartId}/filter-values?game_id=${gameId}`,
  chartCsvDownload: (submoduleId: string, chartId: string, queryParams?: string) =>
    `/visualization/submodules/${submoduleId}/charts/${chartId}/download${queryParams || ''}`,
  dealCashflowDownload: (submoduleId: string) =>
    `/visualization/submodules/${submoduleId}/deal-cashflow/download`,
  downloadFinancingPerformanceReportsCsv: (submoduleId: string) =>
    `/visualization/submodules/${submoduleId}/financing-performance/download`,
  fetchRequestedSubmodules: () => '/v1/submodule-requests',
  requestSubmodule: (requestId: string) => `/v1/submodule-requests/${requestId}/request`,
  enhancedCreditScoreStatus: (gameId: string) =>
    `/v1/funding-eligibility/enhanced/games/${gameId}/status`,
  enhancedCreditScoreRequest: (gameId: string) =>
    `/v1/funding-eligibility/enhanced/games/${gameId}/request`,
  checkSubmoduleEligibilityForGame: (submoduleType: string, gameId: string) =>
    `/v1/submodule-requests/submodules/${submoduleType}/games/${gameId}/eligibility`,
  fetchSubmoduleRequestsForGame: (gameId: string) => `/v1/submodule-requests/games/${gameId}`,

  requestSubmoduleAccess: `/v1/submodule-requests`,
  investmentRequests: '/investments/requests',
  investmentPrepaymentRequests: (gameId?: string) =>
    `/investments/prepayment-requests${gameId ? `?gameId=${gameId}` : ''}`,
  investmentRevenueConfirmation: '/investments/revenue-confirmation',
  investmentRepaymentConfirmation: '/investments/repayment-confirmation',
  investmentRevenueLedgerLastSync: '/investments/revenue-ledger/last-calculated-at',
  investmentContractTemplates: '/investments/contract-templates',
  investmentInvestorSigningAuthorities: '/investments/investor-signing-authorities',
  investmentAdminRequests: '/investments/admin/requests',
  investmentsGamesById: (gameId: string) => `/investments/games/${gameId}`,
  categoriesAndGenres: '/games/category-genre',
  autoCategoryClassify: '/games/auto-category/classify',
  autoCategoryClassifyJob: (jobId: string) => `/games/auto-category/classify/${jobId}`,
  investors: '/investments/admin/investors',
  cohortRevenueExplainer: (gameId: string) => `/investments/cohort-revenue-explainer/${gameId}`,
  cohortRevenueExplainerAvailability: (gameId: string) =>
    `/investments/cohort-revenue-explainer/${gameId}/availability`,
  addGame: '/self-serve/add-new-game',
  applicationDetails: (store: string, appUrl: string) =>
    `/self-serve/verify-game/${store}?appUrl=${encodeURIComponent(appUrl)}`,

  adminRegisterUser: '/self-serve/admin/register',

  selfServeDetails: '/self-serve/details',
  selfServeBasicDetails: '/self-serve/basic-details',
  selfServeUpdateCategoryAndGenre: (selfServeId: string) =>
    `/self-serve/${selfServeId}/category-genre`,
  selfServeUpdateApplicationDetails: (selfServeId: string) => `/self-serve/${selfServeId}`,
  selfServeDashboardRequests: `/self-serve/admin/requests`,
  selfServeDashboardDuplicates: `/self-serve/admin/duplicates`,
  selfServeById: (selfServeId: string) => `/self-serve/admin/request/${selfServeId}`,
  selfServeAggregatedCohortData: (requestId: string) =>
    `/self-serve/${requestId}/aggregate-cohort-data`,
  selfServeDataAccess: (selfServeId: string) => `/self-serve/${selfServeId}/initiate`,
  selfServeEditDataAccess: (selfServeId: string) => `/self-serve/${selfServeId}/account-details`,
  selfServeRequestDashboard: (selfServeId: string, dashboardId: string) =>
    `/self-serve/${selfServeId}/dashboards/${dashboardId}/request`,
  selfServeNDADetails: (selfServeId: string) => `/self-serve/${selfServeId}/nda`,
  selfServeMMPConfig: `/self-serve/mmp-config`,
  selfServeCsvDownload: (queryParams?: string) =>
    `/self-serve/admin/requests/download${queryParams ? `?${queryParams}` : ''}`,
  updateSelfServeStatus: (selfServeId: string) => `/self-serve/admin/update-status/${selfServeId}`,
  uploadNDA: (selfServeId: string) => `/self-serve/admin/upload-nda/${selfServeId}`,
  toggleArchiveStatus: (selfServeId: string) => `/self-serve/admin/toggle-archived/${selfServeId}`,
  selfServeArchiveLog: (selfServeId: string) =>
    `/self-serve/admin/request/${selfServeId}/archive-log`,
  deleteSelfServe: (selfServeId: string) => `/self-serve/admin/delete/${selfServeId}`,
  simulateProjections: () => `/predictions`,
  getPredictions: (gameId: string) => `/predictions/games/${gameId}`,
  editProjections: (predictionId: string) => `/predictions/${predictionId}/user-inputs`,
  selfServeAtachments: (selfServeId: string, attachmentId: string) =>
    `/self-serve/requests/${selfServeId}/attachments/${attachmentId}/download`,
  selfServeDataRequirementDocument: (lang: string) => `/self-serve/doc-url?lang=${lang}`,
  selfServeAggregatedCohortFileUpload: (selfServeId: string) =>
    `/self-serve/upload-data/${selfServeId}`,
  feedback: `/feedback`,
  cohortCount: (submoduleId: string, queryParams?: string) =>
    `/visualization/submodules/${submoduleId}/metadata?gameId=${queryParams || ''}`,
  fundingPercentage: (predictionId: string) => `/predictions/${predictionId}/funding-percentage`,
  deals: `/deals`,
  updateActiveDealEndCohort: (dealId: string) => `/deals/${dealId}/end-cohort`,
  dealContractTemplates: '/deals/contract-templates',
  aggregatedDeals: `/aggregated-deals`,
  aggregatedDealsValidate: `/aggregated-deals/validate`,
  aggregatedDealsByClient: (clientCode: string, filter?: string) =>
    `/aggregated-deals/clients/${clientCode}${filter ? `?filter=${filter}` : ''}`,
  deleteAggregatedDeal: (aggregatedDealId: string) => `/aggregated-deals/${aggregatedDealId}`,
  updateAggregatedDeal: (aggregatedDealId: string) => `/aggregated-deals/${aggregatedDealId}`,
  updateAggregatedDealEndCohort: (aggregatedDealId: string) =>
    `/aggregated-deals/${aggregatedDealId}/end-funding-month`,
  aggregatedDealsEligibleGames: (
    clientCode: string,
    startFundingMonth: string,
    endFundingMonth: string,
  ) =>
    `/aggregated-deals/clients/${clientCode}/eligible-games?startFundingMonth=${startFundingMonth}&endFundingMonth=${endFundingMonth}`,
  games: `/games`,
  gamesV2: `/v2/games`,
  companyDetails: (clientCode: string) => `/companies/${clientCode}/details`,
  gamesFilterOptions: `/games/filter-options`,
  gamesFilterOptionsV2: `/v2/games/filter-options`,
  investorSplits: (gameId: string) => `/games/${gameId}/investor-splits`,
  banks: '/banks',
  getBankDetails: (bankId: string) => `/banks/games/${bankId}`,
  getBankDetailsByBankAccountId: (bankAccountId: string) => `/banks/${bankAccountId}`,
  selfServeAdminAggregatedCohortFileUpload: `/self-serve/admin/upload-data`,
  selfServeMonthlyRefresh: '/self-serve/refresh-config',
  createPortfolio: '/self-serve/admin/request/portfolios',
  portfolioDetails: (portfolioId: string) => `/self-serve/admin/request/portfolios/${portfolioId}`,
  refreshCommissions: '/commissions/refresh',
  commissions: (queryParams?: string) => `/commissions${queryParams ? `?${queryParams}` : ''}`,
  commissionsDownload: (queryParams?: string) =>
    `/commissions/download${queryParams ? `?${queryParams}` : ''}`,
  activeCohorts: (queryParams?: string) =>
    `/commissions/active-cohorts${queryParams ? `?${queryParams}` : ''}`,
  activeCohortsDownload: (queryParams?: string) =>
    `/commissions/active-cohorts/download${queryParams ? `?${queryParams}` : ''}`,
  payouts: (queryParams?: string) => `/commissions/payouts${queryParams ? `?${queryParams}` : ''}`,
  payoutsDownload: (queryParams?: string) =>
    `/commissions/payouts/download${queryParams ? `?${queryParams}` : ''}`,
  payoutsCsvForPayoutsDashboard: (queryParams?: string) =>
    `/payout/payouts/download${queryParams ? `?${queryParams}` : ''}`,
  endingBalance: (queryParams?: string) =>
    `/commissions/ending-balance${queryParams ? `?${queryParams}` : ''}`,
  endingBalanceDownload: (queryParams?: string) =>
    `/commissions/ending-balance/download${queryParams ? `?${queryParams}` : ''}`,
  advancePayouts: (queryParams?: string) =>
    `/commissions/advance-payouts${queryParams ? `?${queryParams}` : ''}`,
  advancePayoutsDownload: (queryParams?: string) =>
    `/commissions/advance-payouts/download${queryParams ? `?${queryParams}` : ''}`,
  updatePayoutStatus: (id: string) => `/commissions/payouts/${id}`,
  markActiveCohortAsDefaulted: (cohortId: string) =>
    `/commissions/active-cohorts/${cohortId}/mark-defaulted`,
  activeCohortDealSources: (gameId: string) => `/commissions/referrers/game/${gameId}`,
  referrers: '/referrers',
  referrersByGameId: (gameId: string) => `/referrers/games/${gameId}`,
  referrerDealMappingItem: (dealMappingId: string) => `/referrers/deal-mapping/${dealMappingId}`,
  referrerPayoutProgress: (gameId: string) => `/referrers/games/${gameId}/payout-progress`,
  commissionsFilters: '/commissions/filters',
  payoutsFitlers: (queryParams?: string) =>
    `/commissions/filters/payouts${queryParams ? `?${queryParams}` : ''}`,
  commissionsTableLevelFilters: '/commissions/filters/tables',
  commissionsChart: (queryParams?: string) =>
    `/commissions/charts${queryParams ? `?${queryParams}` : ''}`,
  commissionsChartsDownload: (queryParams?: string) =>
    `/commissions/charts/download${queryParams ? `?${queryParams}` : ''}`,
  deletePortfolio: (portfolioId: string) => `/self-serve/admin/request/portfolios/${portfolioId}`,
  finalCommissions: (payoutId: string) => `/commissions/payouts/${payoutId}`,
  advancePayoutsForPayoutId: (payoutId: string) => `/commissions/advance-payouts/${payoutId}`,
  dealsCsvDownload: (queryParams?: string) =>
    `/games/download${queryParams ? `?${queryParams}` : ''}`,
  dealsCsvDownloadV2: (queryString?: string) =>
    `/v2/games/download${queryString ? `?${queryString}` : ''}`,
  underwritingCharts: (submoduleId: string, queryParams?: string) =>
    `/visualization/submodules/${submoduleId}/tabs${queryParams}`,

  /* Financial Reporting */
  financialReportingGamesById: (clientCode: string, statementType: string) =>
    `/financial-reports/companies/${clientCode}?statementTypes=${statementType}`,
  financialReportingCurrency: (clientCode: string) =>
    `/companies/${clientCode}/financial-reporting-currency`,
  currencies: '/currencies',
  financialReportingFileUploadUrl: (reportId: string) =>
    `/financial-reports/${reportId}/upload-document`,
  financialReportingFileDownloadUrl: (reportId: string) =>
    `/financial-reports/${reportId}/download-document`,
  financialReportingFileDelete: (reportId: string, documentType: string) =>
    `/financial-reports/${reportId}/delete-document?documentType=${documentType}`,
  financialReportings: '/financial-reports',
  updateFinancialReporting: (reportId: string) => `/financial-reports/${reportId}`,
  submitFinancialReporting: (reportId: string) => `/financial-reports/${reportId}/submit`,
  financialReportConsolidatedEntities: (reportId: string) =>
    `/financial-reports/${reportId}/consolidated-entities`,
  financialReportConsolidatedEntity: (reportId: string, entityId: string) =>
    `/financial-reports/${reportId}/consolidated-entities/${entityId}`,
  financialReportConsolidatedEntityFileDelete: (
    reportId: string,
    entityId: string,
    documentType: string,
  ) =>
    `/financial-reports/${reportId}/consolidated-entities/${entityId}/delete-document?documentType=${documentType}`,
  financialReportConsolidatedEntityFileDownloadUrl: (
    reportId: string,
    entityId: string,
    documentType: string,
  ) =>
    `/financial-reports/${reportId}/consolidated-entities/${entityId}/download-document?documentType=${documentType}`,
  financialReportsAdmin: (queryParams?: string) =>
    `/financial-reports/admin${queryParams ? `?${queryParams}` : ''}`,
  financialReportsAdminDownload: '/financial-reports/admin/download',
  financialReportsAdminGamesById: (clientCode: string) =>
    `/financial-reports/admin/companies/${clientCode}`,
  updateFinancialReportingStatus: (reportId: string) =>
    `/financial-reports/admin/${reportId}/update-status`,

  fetchLastMonthPredictionData: (gameId: string) => `/v2/predictions/current-cohort/${gameId}`,
  createScenario: () => `/predictions`,
  getScenario: (scenarioId: string) => `/predictions/${scenarioId}`,
  deleteScenario: (predictionRequestId: string) => `/predictions/${predictionRequestId}`,
  duplicateScenario: (predictionRequestId: string) =>
    `/predictions/${predictionRequestId}/duplicate`,
  updateScenario: (predictionRequestId: string) => `/predictions/${predictionRequestId}`,
  scenariosListById: (predictionRequestId: string) => `/predictions/${predictionRequestId}`,
  fetchDefaultScenarioDetails: (gameId: string) => `/predictions/default-roas/games/${gameId}`,
  fetchPreviousCohortDetails: (gameId: string) => `/v2/predictions/current-cohort/games/${gameId}`,
  fetchCohortHistoryData: (gameId: string, model: string) =>
    `/predictions/historical?gameId=${gameId}&model=${model}`,
  allowedPvxModels: `/predictions/allowed-models`,
  getTabsFromSubmoduleId: (submoduleId: string, queryParams?: string) =>
    `/visualization/submodules/${submoduleId}/tabs${queryParams}`,
  /* Investor Report */
  /* Investor Report Listing */
  investorReport: (queryParams?: string) =>
    `/investor-report${queryParams ? `?${queryParams}` : ''}`,
  generateInvestorReport: '/investor-report',
  /* Investor Report Create */
  investorReportGamesList: '/investor-report/games',
  adminInvestorReportGamesList: '/investor-report/games/all',
  investorReportReportById: (reportId: string) => `/investor-report/${reportId}`,
  refreshInvestorReport: (reportId: string) => `/investor-report/refresh/${reportId}`,
  generateInvestorReportByGameId: `/investor-report/generate-by-game`,
  uploadGameLogo: (gameId: string) => `/investor-report/upload-logo?gameId=${gameId}`,
  getGameLogo: `/investor-report/logo-url`,
  /* Investor Report View */
  slides: (reportId: string) => `/investor-report/${reportId}/slides`,
  slideById: (reportId: string, slideId: string) =>
    `/investor-report/${reportId}/slides/${slideId}`,
  investorReportPdfById: (reportId: string) => `/investor-report/export/${reportId}`,
  updateSlideData: (reportId: string, slideId: string) =>
    `/investor-report/admin/${reportId}/slides/${slideId}`,
  updateSlideDataClientAllowed: (reportId: string, slideId: string) =>
    `/investor-report/${reportId}/slides/${slideId}`,
  /* Investor Report History */
  getInvestorReportHistory: (reportId: string) => `/investor-report/exports?reportId=${reportId}`,
  deleteInvestorReport: (reportId: string) => `/investor-report/export/${reportId}`,
  getInvestorReportPdfDownloadUrl: (exportId: string) => `/investor-report/export/${exportId}`,
  /* Investor Report Chart Image Upload/Retrieve */
  uploadInvestorReportChartImage: (reportId: string, slideId: string) =>
    `/investor-report/${reportId}/slides/${slideId}/upload-chart`,
  getInvestorReportChartImage: (reportId: string, slideId: string, fileName: string) =>
    `/investor-report/${reportId}/slides/${slideId}/chart-image-url?fileName=${fileName}`,
  generateInvestorReportPdf: (reportId: string) => `/investor-report/${reportId}/generate-report`,
  getInvestorReportGenerationStatus: (exportId: string, reportId: string) =>
    `/investor-report/${reportId}/exports/${exportId}`,
  generateAiCommentary: (reportId: string, slideId: string) =>
    `/investor-report/${reportId}/slides/${slideId}/ai-commentary`,
  generateAiCompanySummary: (reportId: string, slideId: string) =>
    `/investor-report/${reportId}/slides/${slideId}/company-info`,
  updateSkipSlideConfig: (reportId: string, slideId: string) =>
    `/investor-report/${reportId}/slides/${slideId}/config`,
  getInvestorReportSampleReport: `/investor-report/doc-url?lang=EN`,
  /* Investor Report Suggestions */
  investorReportSuggestions: (reportId: string, slideId: string) =>
    `/investor-report/suggestions/${reportId}/slides/${slideId}`,
  investorReportSuggestionsReview: (reportId: string, slideId: string) =>
    `/investor-report/suggestions/${reportId}/slides/${slideId}/review`,
  /* Shared/External Views */
  getShareLinkForInvestorReport: (submoduleType: string, gameId: string) =>
    `/share/submodule/${submoduleType}/game/${gameId}`,
  inviteToEmailForSharing: `/share`,
  getInvestorReportGuests: (shareId: string) => `/share/${shareId}`,
  revokeInvestorReportAccess: (shareId: string, email: string) =>
    `/share/${shareId}?user-email=${email}`,
  updateInvestorReportViewedStatus: (shareId: string) => `/share/${shareId}/viewed`,
  verifyEmailHasAccessForInviteId: (inviteId: string, email: string) =>
    `/share/${inviteId}/verify?user-email=${email}`,
  extractDetailsForInviteId: (inviteId: string) => `/share/${inviteId}/entity`,
  checkInvitationValidity: (invitationId: string) => `/invitations/${invitationId}/verify`,
  extractDetailsForInviteIdV2: (inviteId: string) => `/v2/share/${inviteId}/entity`,

  /* ---- Share & Activity ---- */
  recordShareActivity: (shareId: string) => `/share/${shareId}/activity`,
  investorReportContactDetails: (reportId: string) =>
    `/investor-report/${reportId}/contact-details`,
  /* ---- Share & Activity END ---- */

  /* ---- Investors ---- */
  investorsList: (queryParams?: string) => `/investors${queryParams ? `?${queryParams}` : ''}`,
  investorsEmpaneled: '/investors/empaneled',
  investorById: (id: string) => `/investors/${id}`,
  investorActivity: (id: string) => `/investors/${id}/activity`,
  createInvestor: '/investors',
  updateInvestor: (id: string) => `/investors/${id}`,
  deleteInvestor: (id: string) => `/investors/${id}`,
  uploadInvestorLogo: '/investors/upload-logo',
  investorLogoUrl: (fileName: string) =>
    `/investors/logo-url?fileName=${encodeURIComponent(fileName)}`,
  /* ---- Investors END ---- */

  /* ---- Investors V2 ---- */
  investorByIdV2: (id: string) => `/v2/investors/${id}`,
  investorActivityV2: (id: string) => `/v2/investors/${id}/activity`,
  updateInvestorV2: (id: string) => `/v2/investors/${id}`,
  deleteInvestorV2: (id: string) => `/v2/investors/${id}`,
  /* ---- Investors V2 END ---- */

  /* ---- Investor Report Sharing ---- */
  investorReportSharedGames: '/investor-report/games/shared',
  shareInvestorReport: (reportId: string) => `/investor-report/reports/${reportId}/share`,
  revokeInvestorReportShare: (reportId: string, accessType: string, accessId: string) =>
    `/investor-report/reports/${reportId}/share/${accessType}/${accessId}`,
  /* ---- Investor Report Sharing END ---- */

  /* ---- Investor Report V2 ---- */
  investorReportV2Listing: '/v2/investor-report',
  investorReportV2ByClientCode: (clientCode: string) => `/v2/investor-report/company/${clientCode}`,
  investorReportV2SlidesByClientCode: (clientCode: string) =>
    `/v2/investor-report/company/${clientCode}/slides`,
  investorReportV2SlideById: (clientCode: string, slideId: string) =>
    `/v2/investor-report/company/${clientCode}/slides/${slideId}`,
  investorReportV2Generate: '/v2/investor-report',
  investorReportV2AllCompanies: '/v2/investor-report/company/all',
  investorReportV2Companies: '/v2/investor-report/company',
  investorReportV2CompanyStatus: (clientCode: string) =>
    `/v2/investor-report/company/${clientCode}/status`,
  investorReportV2CompanyRefresh: (clientCode: string) =>
    `/v2/investor-report/company/${clientCode}/refresh`,
  investorReportV2CompanySlideAiCommentary: (clientCode: string, slideId: string) =>
    `/v2/investor-report/company/${clientCode}/slides/${slideId}/ai-commentary`,
  investorReportV2CompanySlideCompanyInfo: (clientCode: string, slideId: string) =>
    `/v2/investor-report/company/${clientCode}/slides/${slideId}/company-info`,
  investorReportV2UpdateSlide: (clientCode: string, slideId: string) =>
    `/v2/investor-report/admin/company/${clientCode}/slides/${slideId}`,
  investorReportV2UpdateSlideClientAllowed: (clientCode: string, slideId: string) =>
    `/v2/investor-report/company/${clientCode}/slides/${slideId}`,
  investorReportV2UploadChartImage: (clientCode: string, slideId: string) =>
    `/v2/investor-report/company/${clientCode}/slides/${slideId}/upload-chart`,
  investorReportV2GetChartImageUrl: (clientCode: string, slideId: string, fileName: string) =>
    `/v2/investor-report/company/${clientCode}/slides/${slideId}/chart-image-url?fileName=${encodeURIComponent(fileName)}`,
  investorReportV2UpdateSkipSlideConfig: (clientCode: string, slideId: string) =>
    `/v2/investor-report/company/${clientCode}/slides/${slideId}/config`,
  investorReportAdminV2UpdateSkipSlideConfig: (clientCode: string, slideId: string) =>
    `/v2/investor-report/admin/company/${clientCode}/slides/${slideId}/config`,
  investorReportV2BatchGenerateAiCommentary: (clientCode: string) =>
    `/v2/investor-report/company/${clientCode}/ai-commentary`,
  investorReportV2CompanyShare: (clientCode: string) =>
    `/v2/investor-report/company/${clientCode}/share`,
  investorReportV2CompanyRevokeShare: (clientCode: string, accessType: string, accessId: string) =>
    `/v2/investor-report/company/${clientCode}/share/${accessType}/${accessId}`,
  investorReportV2CompanyShareLink: (clientCode: string, submoduleType: string) =>
    `/share/submodule/${submoduleType}/entity/${clientCode}`,
  investorReportV2CompanyContactDetails: (clientCode: string) =>
    `/v2/investor-report/company/${clientCode}/contact-details`,
  investorReportV2SharedGames: '/v2/investor-report/company/shared',
  /* Investor Report Suggestions */
  investorReportV2GetSuggestions: (clientCode: string, slideId: string) =>
    `/investor-report/suggestions/company/${clientCode}/slides/${slideId}`,
  investorReportV2Suggestions: (clientCode: string, slideId: string) =>
    `/investor-report/suggestions/company/${clientCode}/slides/${slideId}`,
  investorReportV2SuggestionsReview: (clientCode: string, slideId: string) =>
    `/investor-report/suggestions/company/${clientCode}/slides/${slideId}/review`,
  /* ---- Investor Report V2 END ---- */

  /* Game Thresholds */
  getPerformanceThresholds: (gameId: string) => `/game-thresholds/games/${gameId}`,
  updatePerformanceThresholds: (gameId: string) => `/game-thresholds/games/${gameId}`,
  getGameThresholds: (gameId: string, type?: string) =>
    `/game-thresholds/games/${gameId}${type ? `?type=${type}` : ''}`,
  getThresholdsByDealStructure: (gameId: string, dealStructureId: string) =>
    `/game-thresholds/games/${gameId}/deal-structures/${dealStructureId}`,
  updateThresholdsByDealStructure: (gameId: string, dealStructureId: string) =>
    `/game-thresholds/games/${gameId}/deal-structures/${dealStructureId}`,
  adHocAdjustments: '/ad-hoc-adjustments',
  adHocAdjustmentTransferPeriods: (gameId: string) =>
    `/ad-hoc-adjustments/transfer-periods?gameId=${gameId}`,
  getFinancialProjectionsSummary: (gameId: string, queryParams?: string) =>
    `/v2/predictions/games/${gameId}/summary${queryParams ? `?${queryParams}` : ''}`,
  getAlertConfiguration: (queryParams: string) =>
    `/v1/alerts/threshold-configs${queryParams ? `?${queryParams}` : ''}`,
  getAlertFilters: '/v1/alerts/configs',
  editThresholdConfig: (configId: string) => `/v1/alerts/threshold-configs/${configId}/threshold`,
  editAlertFrequency: (configId: string) => `/v1/alerts/threshold-configs/${configId}/schedule`,
  getAlertDetailByAlertId: (alertId: string) => `/v1/alerts/${alertId}`,
  pauseAlert: (configId: string) => `/v1/alerts/threshold-configs/${configId}/pause`,
  resumeAlert: (configId: string) => `/v1/alerts/threshold-configs/${configId}/resume`,
  getAlertDetails: (queryParams: string) => `/v1/alerts?${queryParams}`,

  resolveAlert: '/v1/alerts/resolve',
  recalculateAlert: '/v1/alerts/recalculate',
  getAlertCount: (queryParams: string) => `/v1/alerts/count${queryParams ? `?${queryParams}` : ''}`,
  basicGameDetails: '/games/basic-details',
  getDealNames: '/v1/alerts/games',
  auditLogs: (gameId: string) => `/games/${gameId}/audit-logs`,
  dealSetupLastUpdatedDetails: (gameId: string) => `/games/${gameId}/audit-logs/last-updated-by`,
  getPvxPoc: '/games/pvx-poc',
  excludedFromAccountingRevenue: '/games/excluded-from-accounting-revenue',
  getDisallowedDataSources: (selfServeId: string) =>
    `/self-serve/${selfServeId}/disallowed-data-sources`,
  deleteSelfServeByClient: (selfServeId: string) => `/self-serve/${selfServeId}`,

  /* Liquidity Providers */
  liquidityProviders: '/v1/liquidity-providers',
  liquidityProvidersPerformance: '/v1/liquidity-providers/performance',
  liquidityProviderById: (liquidityProviderId: string) =>
    `/v1/liquidity-providers/${liquidityProviderId}`,
  liquidityProviderCapitalCalls: (liquidityProviderId: string) =>
    `/v1/liquidity-providers/${liquidityProviderId}/capital-calls`,

  /* Fund Allocations */
  fundAllocationFilters: '/v1/fund-allocations/filters',
  fundAllocationSummary: (month: string) => `/v1/fund-allocations/summary?month=${month}`,
  fundAllocationCombinations: (month: string) => `/v1/fund-allocations/combinations?month=${month}`,
  fundAllocationRecalculate: '/v1/fund-allocations/calculate',
  fundAllocationApply: '/v1/fund-allocations/apply',

  /* Financial Projections » Model Requests */
  getModelRequests: (submoduleType: string) => `/v1/submodule-requests/submodules/${submoduleType}`,
  publishModelRequest: (requestId: string) => `/v1/submodule-requests/${requestId}/enable`,
  getSubmoduleFeatureEnabled: (submoduleType: string) =>
    `/v1/submodule-requests/submodules/${submoduleType}/feature-enabled`,
  retryModelRequest: (submoduleRequestId: string) =>
    `/v1/submodule-requests/${submoduleRequestId}/retry`,
  getSuggestedAllocations: `/v1/fund-allocations/combinations/suggested-allocations`,

  /* Financial Projections » Spend Impact */
  getSpendImpactSummary: (gameId: string) => `/v2/spend-impact/games/${gameId}/summary`,
  getSpendImpactProjection: (gameId: string) => `/v2/spend-impact/games/${gameId}/projection`,
  getSpendImpactProjectionDownload: (gameId: string) =>
    `/v2/spend-impact/games/${gameId}/projection/download`,

  /* Due Diligence */
  dueDiligence: (queryParams?: string) =>
    `/v1/due-diligence${queryParams ? `?${queryParams}` : ''}`,
  preliminaryDueDiligence: (queryParams?: string) =>
    `/v1/preliminary-due-diligence${queryParams ? `?${queryParams}` : ''}`,
  dueDiligenceTemplates: '/v1/due-diligence/templates',
  dueDiligenceTemplateById: (templateId: string) => `/v1/due-diligence/templates/${templateId}`,
  dueDiligenceCompanies: '/v1/due-diligence/available-companies',
  dueDiligenceClients: '/v1/due-diligence/clients',
  dueDiligenceByClient: (clientCode: string) => `/v1/due-diligence/clients/${clientCode}`,
  dueDiligenceItemConversations: (itemId: string) =>
    `/v1/due-diligence/items/${itemId}/conversations`,
  dueDiligenceItemConversation: (itemId: string, conversationId: string) =>
    `/v1/due-diligence/items/${itemId}/conversations/${conversationId}`,
  dueDiligenceItemNotApplicable: (itemId: string) =>
    `/v1/due-diligence/items/${itemId}/not-applicable`,
  dueDiligenceItemReceived: (itemId: string) => `/v1/due-diligence/items/${itemId}/received`,
  dueDiligenceItemReopen: (itemId: string) => `/v1/due-diligence/items/${itemId}/reopen`,
  dueDiligenceItemFields: (itemId: string) => `/v1/due-diligence/items/${itemId}/fields`,
  dueDiligenceItem: (itemId: string) => `/v1/due-diligence/items/${itemId}`,
  dueDiligenceItemSections: (itemId: string) => `/v1/due-diligence/items/${itemId}/sections`,
  dueDiligenceItemBusinessVerificationSession: (itemId: string) =>
    `/v1/due-diligence/items/${itemId}/business-verification/session`,
  dueDiligenceItemBusinessVerificationCompleted: (itemId: string) =>
    `/v1/due-diligence/items/${itemId}/business-verification/completed`,
  dueDiligenceFieldDocumentVerification: (itemId: string, fieldId: string) =>
    `/v1/due-diligence/items/${itemId}/fields/${fieldId}/document-verification`,
  dueDiligenceItemDocumentVerifications: (itemId: string) =>
    `/v1/due-diligence/items/${itemId}/document-verifications`,
  dueDiligenceItemAttachmentDocumentVerification: (itemId: string, attachmentId: string) =>
    `/v1/due-diligence/items/${itemId}/attachments/${attachmentId}/document-verifications`,
  dueDiligenceItemDocumentVerificationsRetry: (itemId: string) =>
    `/v1/due-diligence/items/${itemId}/document-verifications/retry`,
  dueDiligenceItemAdminSections: (itemId: string) =>
    `/v1/due-diligence/items/${itemId}/admin/sections`,
  dueDiligenceScreening: (dueDiligenceId: string) =>
    `/v1/due-diligence/${dueDiligenceId}/screening`,
  dueDiligenceScreeningReRun: (dueDiligenceId: string) =>
    `/v1/due-diligence/${dueDiligenceId}/screening/run`,
  dueDiligenceRunwayAnalysis: (dueDiligenceId: string) =>
    `/v1/due-diligence/${dueDiligenceId}/screening/runway-analysis`,
  dueDiligenceRunwayAnalysisReset: (dueDiligenceId: string) =>
    `/v1/due-diligence/${dueDiligenceId}/screening/runway-analysis/reset`,
  dueDiligenceRunwayAnalysisCsv: (dueDiligenceId: string) =>
    `/v1/due-diligence/${dueDiligenceId}/screening/runway-analysis/csv`,
  dueDiligenceRunwayAnalysisComponents: (dueDiligenceId: string, query?: string) =>
    `/v1/due-diligence/${dueDiligenceId}/screening/runway-analysis/components${
      query ? `?${query}` : ''
    }`,
  dueDiligenceRunwayAnalysisComponent: (dueDiligenceId: string, componentId: string) =>
    `/v1/due-diligence/${dueDiligenceId}/screening/runway-analysis/components/${componentId}`,
  dueDiligenceRunwayAnalysisAdjustedEbitdaParams: (dueDiligenceId: string) =>
    `/v1/due-diligence/${dueDiligenceId}/screening/runway-analysis/adjusted-ebitda/params`,
  dueDiligenceDebtRepayment: (dueDiligenceId: string) =>
    `/v1/due-diligence/${dueDiligenceId}/screening/runway-analysis/loans/repayments`,
  dueDiligenceLoanDetails: (dueDiligenceId: string, query?: string) =>
    `/v1/due-diligence/${dueDiligenceId}/screening/runway-analysis/loans${query ? `?${query}` : ''}`,
  dueDiligenceLoanDetailsCsv: (dueDiligenceId: string) =>
    `/v1/due-diligence/${dueDiligenceId}/screening/runway-analysis/loans/csv`,
  dueDiligenceLoanPaymentSchedule: (dueDiligenceId: string, query?: string) =>
    `/v1/due-diligence/${dueDiligenceId}/screening/runway-analysis/loans/payment-schedule${query ? `?${query}` : ''}`,
  dueDiligenceLoanPaymentScheduleFilters: (dueDiligenceId: string) =>
    `/v1/due-diligence/${dueDiligenceId}/screening/runway-analysis/loans/payment-schedule/filters`,
  dueDiligenceLoanPaymentScheduleCsv: (dueDiligenceId: string) =>
    `/v1/due-diligence/${dueDiligenceId}/screening/runway-analysis/loans/payment-schedule/csv`,
  dueDiligenceItemFollowUpIssues: (itemId: string) =>
    `/v1/due-diligence/items/${itemId}/follow-up-issues`,
  dueDiligenceItemFollowUpIssueActions: (itemId: string) =>
    `/v1/due-diligence/items/${itemId}/follow-up-issues/actions`,
  dueDiligenceItemAttachments: (itemId: string) => `/v1/due-diligence/items/${itemId}/attachments`,
  dueDiligenceItemAttachmentDelete: (itemId: string, attachmentId: string) =>
    `/v1/due-diligence/items/${itemId}/attachments/${attachmentId}`,
  dueDiligenceItemAttachmentDownloadUrl: (itemId: string, attachmentId: string) =>
    `/v1/due-diligence/items/${itemId}/attachments/${attachmentId}/download-url`,
  dueDiligenceSendReminder: (clientCode: string) =>
    `/v1/due-diligence/clients/${clientCode}/send-reminder`,
  dueDiligenceSummary: (clientCode: string) => `/v1/due-diligence/clients/${clientCode}/summary`,
  dueDiligenceItemAttachmentsDownloadZip: (itemId: string) =>
    `/v1/due-diligence/items/${itemId}/attachments/download-zip`,
  closeDueDiligence: (clientCode: string) => `/v1/due-diligence/clients/${clientCode}/close`,
  dueDiligenceClientItems: (clientCode: string) => `/v1/due-diligence/clients/${clientCode}/items`,
  companiesClientCodesPocEmails: (clientCode: string) =>
    `/companies/client-codes/${clientCode}/poc-emails`,
  dueDiligenceClientPocEmails: (clientCode: string) =>
    `/v1/due-diligence/clients/${clientCode}/poc-emails`,
  dueDiligencePause: (clientCode: string) => `/v1/due-diligence/clients/${clientCode}/pause`,
  dueDiligenceResume: (clientCode: string) => `/v1/due-diligence/clients/${clientCode}/resume`,
  dueDiligenceUpdateDueDate: (clientCode: string) =>
    `/v1/due-diligence/clients/${clientCode}/due-date`,
  dueDiligenceSampleResponseDownloadUrl: (filename: string) =>
    `/v1/due-diligence/sample-responses/download-url?filename=${encodeURIComponent(filename)}`,
  dueDiligenceAttachmentsSummary: (dueDiligenceId: string) =>
    `/v1/due-diligence/${dueDiligenceId}/attachments/summary`,
  dueDiligenceAttachmentsDownloadZip: (dueDiligenceId: string) =>
    `/v1/due-diligence/${dueDiligenceId}/attachments/download-zip`,

  /* Preliminary Due Diligence */
  preliminaryDueDiligenceCreate: '/v1/preliminary-due-diligence',
  preliminaryDueDiligenceByClient: (clientCode: string) =>
    `/v1/preliminary-due-diligence/clients/${clientCode}`,
  preliminaryDueDiligenceClientItems: (clientCode: string) =>
    `/v1/preliminary-due-diligence/clients/${clientCode}/items`,
  preliminaryDueDiligenceItemStatus: (itemId: string) =>
    `/v1/preliminary-due-diligence/items/${itemId}/status`,
  preliminaryDueDiligenceSubmit: (clientCode: string) =>
    `/v1/preliminary-due-diligence/clients/${clientCode}/submit`,
  preliminaryDueDiligenceReopen: (clientCode: string) =>
    `/v1/preliminary-due-diligence/clients/${clientCode}/reopen`,
  preliminaryDueDiligenceAttachmentDownloadUrl: (itemId: string, attachmentId: string) =>
    `/v1/preliminary-due-diligence/items/${itemId}/attachments/${attachmentId}/download-url`,
  preliminaryDueDiligenceAttachmentDelete: (itemId: string, attachmentId: string) =>
    `/v1/preliminary-due-diligence/items/${itemId}/attachments/${attachmentId}`,
  preliminaryDueDiligenceReceive: (clientCode: string) =>
    `/v1/preliminary-due-diligence/clients/${clientCode}/receive`,
  preliminaryDueDiligenceSendReminder: (clientCode: string) =>
    `/v1/preliminary-due-diligence/clients/${clientCode}/send-reminder`,
  preliminaryDueDiligenceItemConversations: (itemId: string) =>
    `/v1/preliminary-due-diligence/items/${itemId}/conversations`,
  preliminaryDueDiligenceItemConversation: (itemId: string, conversationId: string) =>
    `/v1/preliminary-due-diligence/items/${itemId}/conversations/${conversationId}`,
  preliminaryDueDiligenceTemplates: '/v1/preliminary-due-diligence/templates',
  preliminaryDueDiligenceClients: '/v1/preliminary-due-diligence/clients',
  preliminaryDueDiligenceAvailableCompanies: '/v1/preliminary-due-diligence/available-companies',
  preliminaryDueDiligenceItemAttachments: (itemId: string) =>
    `/v1/preliminary-due-diligence/items/${itemId}/attachments`,
  preliminaryDueDiligencePause: (clientCode: string) =>
    `/v1/preliminary-due-diligence/clients/${clientCode}/pause`,
  preliminaryDueDiligenceResume: (clientCode: string) =>
    `/v1/preliminary-due-diligence/clients/${clientCode}/resume`,
  preliminaryDueDiligenceUpdateDueDate: (clientCode: string) =>
    `/v1/preliminary-due-diligence/clients/${clientCode}/due-date`,
  preliminaryDueDiligencePocEmails: (clientCode: string) =>
    `/v1/preliminary-due-diligence/clients/${clientCode}/poc-emails`,
  preliminaryDueDiligenceAttachmentsDownloadZip: (preliminaryDueDiligenceId: string) =>
    `/v1/preliminary-due-diligence/${preliminaryDueDiligenceId}/attachments/download-zip`,
  preliminaryDueDiligenceAttachmentsSummary: (preliminaryDueDiligenceId: string) =>
    `/v1/preliminary-due-diligence/${preliminaryDueDiligenceId}/attachments/summary`,

  portfolioGames: (submoduleId: string, gameId: string) =>
    `/visualization/submodules/${submoduleId}/games/${gameId}/portfolio-games`,
  /* Exposure Forecasting */
  exposureForecastingDeals: '/v1/exposure-forecasting/games',
  exposureForecastingChartDetails: (chartId: string) => `/v1/exposure-forecasting/chart/${chartId}`,
  exposureForecastingRecalculate: '/v1/exposure-forecasting/recalculate',
  exposureForecastingCreate: '/v1/exposure-forecasting',
  exposureForecastingUpdate: (dealId: string) => `/v1/exposure-forecasting/${dealId}`,
  exposureForecastingRetrieve: (dealId: string) => `/v1/exposure-forecasting/${dealId}`,
  exposureForecastingDelete: (id: string) => `/v1/exposure-forecasting/${id}`,
  exposureForecastingRoasCurve: (dealId: string) => `/v1/exposure-forecasting/roas-curve/${dealId}`,
  exposureForecastingRefreshRoasAverage: (gameId: string) => `/v1/roas-average/${gameId}/refresh`,
  exposureForecastingAvailableDeals: '/v1/exposure-forecasting/available-deals',
  exposureForecastingDownload: '/v1/exposure-forecasting/download',
  exposureForecastingBreakdownAnalysis: (gameId: string) =>
    `/v1/exposure-forecasting/${gameId}/download`,
  exposureForecastingRefresh: (gameId: string) => `/v1/exposure-forecasting/${gameId}/refresh`,
  /* Exposure Forecasting END */

  // Market Intelligence
  getSalesPersons: '/v1/market-intelligence/sales-persons',
  assignOwnerToPublisher: '/v1/market-intelligence/deals/assign',
  unassignPublisherFromDeal: '/v1/market-intelligence/deals/unassign',
  getSummary: '/v1/market-intelligence/metadata',
  getFilterOptions: '/v1/market-intelligence/filters',
  getIntelligenceData: (appId: string) =>
    `/v1/market-intelligence/apps/${appId}/creative-intelligence`,
  publisherApps: (publisherId: number | string) =>
    `/v1/market-intelligence/publishers/${publisherId}/apps`,
  marketIntelligenceTable: '/v1/market-intelligence/dashboard',
  downloadMarketIntelligenceTable: '/v1/market-intelligence/dashboard/download',
  updateSalesPersonQuota: '/v1/market-intelligence/sales-persons/quota',

  // Market Scan
  marketScanReports: '/v1/market-scan/reports',
  openMarketScanReport: (combinationId: string) => `/v1/market-scan/reports/${combinationId}/open`,
  downloadMarketScanReport: (combinationId: string) =>
    `/v1/market-scan/reports/${combinationId}/download`,

  /* Client User Management */
  clientsList: '/client-user-management/clients',
  clientUserManagementUsers: (clientCode: string, queryParams?: string) =>
    `/client-user-management/${clientCode}/users${queryParams ? `?${queryParams}` : ''}`,
  clientUserManagementDashboards: (clientCode: string) =>
    `/client-user-management/${clientCode}/dashboards`,
  inviteUser: (clientCode: string) => `/client-user-management/${clientCode}/users/invite`,
  updateUserAccess: (clientCode: string, membershipGrantId: string) =>
    `/client-user-management/${clientCode}/users/${membershipGrantId}`,
  revokeUserAccess: (clientCode: string, membershipGrantId: string) =>
    `/client-user-management/${clientCode}/users/${membershipGrantId}/revoke`,
  pendingAccessRequests: (clientCode: string) =>
    `/client-user-management/${clientCode}/access-requests`,
  acceptAccessRequest: (clientCode: string, requestId: string) =>
    `/client-user-management/${clientCode}/access-requests/${requestId}/approve`,
  rejectAccessRequest: (clientCode: string, requestId: string) =>
    `/client-user-management/${clientCode}/access-requests/${requestId}/reject`,

  /* Bank Transfer */
  bankTransfer: (queryParams?: string) => `/payments${queryParams ? `?${queryParams}` : ''}`,
  bankTransferFilters: (queryParams?: string) =>
    `/payments/filters${queryParams ? `?${queryParams}` : ''}`,
  recordPaymentDetails: (transactionId: string) => `/payments/${transactionId}`,
  getBankTransferDetails: (transactionId: string) => `/payments/${transactionId}`,
  getBankTransferAttachment: (paymentId: string, attachmentId: string) =>
    `/payments/${paymentId}/attachments/${attachmentId}/download`,
  downloadBankTransferCsv: (queryParams?: string) =>
    `/payments/download${queryParams ? `?${queryParams}` : ''}`,
  validateInvoiceByBankAccountId: (referrerBankAccountId: string) =>
    `/payments/banks/${referrerBankAccountId}/validate-invoice`,
  validateInvoiceByClientCode: (clientCode: string) =>
    `/payments/clients/${clientCode}/validate-invoice`,

  /* Pending Workspace Signups */
  pendingWorkspaceSignups: '/users/pending-workspace-signups',

  /* Admin User Management - Client users */
  clientUsers: '/client-user-management/admin/clients',

  /* Liquidity Analysis */
  liquidityAnalysisRunwayAnalysis: '/financial-reports/runway-analysis',
  liquidityAnalysisScenariosForReport: '/financial-reports/scenarios',
  liquidityAnalysisScenarios: '/financial-reports/scenarios',
  liquidityAnalysisScenarioById: (scenarioId: string) =>
    `/financial-reports/scenarios/${scenarioId}`,
  liquidityAnalysisScenarioGlobalsById: (reportId: string) =>
    `/financial-reports/${reportId}/update-inputs`,
  liquidityAnalysisScenarioCopy: (scenarioId: string) =>
    `/financial-reports/scenarios/${scenarioId}/copy`,
  liquidityAnalysisRunwayAnalysisOutput: (reportId: string, scenarioId: string) =>
    `/financial-reports/${reportId}/scenarios/${scenarioId}/runway-analysis`,
  liquidityAnalysisCurrentCohortRoasCurve: '/financial-reports/current-cohort-roas-curve',
  liquidityAnalysisRefreshCurrentCohortRoasCurve:
    '/financial-reports/current-cohort-roas-curve/refresh',
  liquidityAnalysisSubmitRunwayAnalysis: (reportId: string) =>
    `/financial-reports/${reportId}/review`,
  /** @deprecated Use `liquidityAnalysisAttachmentDownload`, which is scoped to the company. */
  liquidityAnalysisSignedUrl: (attachmentId: string) =>
    `/financial-reports/runway-analysis/attachments/${attachmentId}/download`,
  liquidityAnalysisAttachmentDownload: (clientCode: string, attachmentId: string) =>
    `/financial-reports/companies/${clientCode}/runway-analysis/attachments/${attachmentId}/download`,
  reopenLiquidityAnalysis: (reportId: string) => `/financial-reports/${reportId}/reopen`,

  /* PvX Impact */
  pvxImpactCompanies: `/v1/impact-report/companies`,
  pvxImpactGenerateReport: (clientCode: string) => `/v1/impact-report/clients/${clientCode}`,
  pvxImpactReportDetails: (clientCode: string) => `/v1/impact-report/clients/${clientCode}`,
  pvxImpactRefreshReport: (clientCode: string) => `/v1/impact-report/clients/${clientCode}/refresh`,
  pvxImpactCohortPerformanceSummary: (clientCode: string) =>
    `/v1/impact-report/clients/${clientCode}/cohort-performance-summary`,
  pvxImpactGrossMarginSafety: (clientCode: string) =>
    `/v1/impact-report/clients/${clientCode}/gross-margin-safety`,
  pvxImpactGrossMarginSafetyParams: (clientCode: string) =>
    `/v1/impact-report/clients/${clientCode}/gross-margin-safety/params`,
  pvxImpactSummaryCards: (clientCode: string) =>
    `/v1/impact-report/clients/${clientCode}/summary-cards`,
  pvxImpactUpdateSummaryCard: (clientCode: string, cardId: string) =>
    `/v1/impact-report/clients/${clientCode}/summary-cards/${cardId}`,
  pvxImpactResetSummaryCards: (clientCode: string) =>
    `/v1/impact-report/clients/${clientCode}/summary-cards/reset`,
  pvxImpactHideSummaryCard: (clientCode: string, cardId: string) =>
    `/v1/impact-report/clients/${clientCode}/summary-cards/${cardId}/hide`,

  /* Admin User Management - PvX Partners */
  companiesBasicDetails: '/companies/basic-details',
  pvxPartners: '/client-user-management/admin/partners',
  pvxPartnerDashboards: (clientCode: string) => `/client-user-management/${clientCode}/dashboards`,
  pvxPartnerFilterEntitlements: (clientCode: string) =>
    `/client-user-management/${clientCode}/filter-entitlements`,
  pvxPartnerProfile: (clientCode: string) =>
    `/client-user-management/${clientCode}/partner-profile`,

  /* Lambda Bot */
  lambdaBotChat: '/v1/lambda-intelligence/chat',
  lambdaBotFeedback: '/v1/lambda-intelligence/feedback',
  lambdaBotHistory: '/v1/lambda-intelligence/history',
  lambdaBotSchema: '/v1/lambda-intelligence/schema',

  /* Financial Projection V2 Unified Projections */
  /* Scenarios */
  getScenarioConfigV2: () => `/v2/predictions/config`,
  createScenarioV2: () => '/v2/predictions',
  editScenarioV2: (predictionRequestId: string) => `/v2/predictions/${predictionRequestId}`,
  deleteScenarioV2: (predictionRequestId: string) => `/v2/predictions/${predictionRequestId}`,
  duplicateScenarioV2: (predictionRequestId: string) =>
    `/v2/predictions/${predictionRequestId}/duplicate`,
  getScenarioByIdV2: (predictionRequestId: string) => `/v2/predictions/${predictionRequestId}`,
  getScenariosListV2: (gameId: string, queryParams?: string) =>
    `/v2/predictions/games/${gameId}${queryParams ? `?${queryParams}` : ''}`,
  getScenarioDefaultDetailsV2: (gameId: string) => `/v2/predictions/defaults/games/${gameId}`,
  getPreviousCohortDetailsV2: (gameId: string) => `/v2/predictions/historical/games/${gameId}`,
  getScenarioAuditLogV2: (predictionRequestId: string) =>
    `/v2/predictions/${predictionRequestId}/audit-log`,
  getScenarioByVersionV2: (predictionRequestId: string, paramVersion: number) =>
    `/v2/predictions/${predictionRequestId}?paramVersion=${paramVersion}`,

  /* Prepayment */
  prepaymentRequests: (queryParams?: string) =>
    `/prepayment-requests${queryParams ? `?${queryParams}` : ''}`,
  prepaymentRequestCreate: (gameId: string) => `/prepayment-requests/games/${gameId}`,
  prepaymentRequestDetails: (id: string) => `/prepayment-requests/${id}`,
  eligibleCohorts: (gameId: string) => `/prepayment-requests/games/${gameId}/eligible-cohorts`,
  eligibleCohortDetails: (gameId: string, cohort: string) =>
    `/prepayment-requests/games/${gameId}/eligible-cohorts/${cohort}`,

  /* Payment Profile */
  paymentProfileOptions: '/v1/payment-profile/options',
  paymentProfileByClient: `/v1/payment-profile`,
  paymentProfileByClientCode: (clientCode: string) =>
    `/v2/payment-profile/clientcode/${clientCode}`,

  /* Notification Preferences */
  notificationPreferences: '/v1/notification-preferences',
  notificationPreferencesDoNotContact: '/v1/notification-preferences/do-not-contact',

  /* Admin Notification Category Config */
  adminNotificationCategoryConfig: '/admin/notification-category-config',
  adminNotificationCategoryConfigByCategory: (mainCategory: string) =>
    `/admin/notification-category-config/${mainCategory}`,
};
